import React, { useEffect, useState } from 'react'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import ArrowDown from '../../assets/icons/ArrowDown'

function FilterList({subCategoryId="",setSubCategoryId=()=>{},  type="drop", data, setCategoryId=()=>{}, categoryId=""}) {
    const [visible, setVisible] = useState(false);
    useEffect(()=>{
        if(subCategoryId !==""){
            setVisible(true)
        }
    },[subCategoryId])
  return (
    <li className='bg-gray-100 min-h-[43px] px-[10px] rounded-[5px] cursor-pointer '>
        <div onClick={()=>{setVisible(!visible); setCategoryId(data?.id); setSubCategoryId("")}} className={`flex items-center min-h-[43px] items-center justify-between group hover-left-animation ${categoryId!=="" && data?.id == categoryId?"active-left":""}`}>
            <button  className='text-black group-hover:text-[--red] text-[17px] font-[600] group-hover:text-white relative transition-all duration-300'>{data?.translate?.title}</button>
        {
            type == "button"?
            <ArrowRightIcon color="var(--red)" />:
            <ArrowDown width={25} height={25} color="var(--red)" />
        }
        </div>
        {
            visible && data?.sub_categories?.length !==0?
            <ul className='p-[7px] flex flex-col gap-[4px] sub-category'>
                {
                    data?.sub_categories?.map((item, j) =>{
                        return(
                             <li key={j} onClick={()=>{setCategoryId(item?.category_id); setSubCategoryId(item?.id)}} className={`hover-left-animation p-[0_4px] min-h-[36px] bg-[white] flex items-center group rounded-[5px] ${subCategoryId!=="" && item?.id == subCategoryId?"active-left":""}`}>
                                <button  className='text-[16px] font-[500] group-hover:text-white relative transition-all duration-300'>{item?.translate?.title}</button>
                            </li>
                        )
                    })
                }
            </ul>:null
        }
      
    </li>
  )
}

export default FilterList
